export const ratingsData = [
  {
    name: "John Doe",
    university: "Harvard University",
    photo: "https://randomuser.me/api/portraits/men/1.jpg", // Dummy photo URL
    rating: 4.5,
    message:
      "Amazing experience! The professors are top-notch, and the campus is beautiful. experience! The professors are top-notch, and the campus is beautiful. experience! The professors are top-notch, and the campus is beautiful.",
  },
  {
    name: "Jane Smith",
    university: "Stanford University",
    photo: "https://randomuser.me/api/portraits/women/2.jpg", // Dummy photo URL
    rating: 3.8,
    message:
      "Great university, but the workload can be overwhelming at times. experience! The professors are top-notch, and the campus is beautiful. experience! The professors are top-notch, and the campus is beautiful.",
  },
  {
    name: "Mark Johnson",
    university: "University of Oxford",
    photo: "https://randomuser.me/api/portraits/men/3.jpg", // Dummy photo URL
    rating: 4.0,
    message:
      "A great learning experience with a vibrant student community. experience! The professors are top-notch, and the campus is beautiful. experience! The professors are top-notch, and the campus is beautiful.",
  },
  {
    name: "Emily Davis",
    university: "MIT",
    photo: "https://randomuser.me/api/portraits/women/4.jpg", // Dummy photo URL
    rating: 5.0,
    message:
      "Hands down the best decision of my life! The resources and networking opportunities are endless. experience! The professors are top-notch, and the campus is beautiful. experience! The professors are top-notch, and the campus is beautiful.",
  },
  {
    name: "John Doe",
    university: "Harvard University",
    photo: "https://randomuser.me/api/portraits/men/1.jpg", // Dummy photo URL
    rating: 4.5,
    message:
      "Amazing experience! The professors are top-notch, and the campus is beautiful. experience! The professors are top-notch, and the campus is beautiful. experience! The professors are top-notch, and the campus is beautiful.",
  },
  {
    name: "Jane Smith",
    university: "Stanford University",
    photo: "https://randomuser.me/api/portraits/women/2.jpg", // Dummy photo URL
    rating: 3.8,
    message:
      "Great university, but the workload can be overwhelming at times. experience! The professors are top-notch, and the campus is beautiful. experience! The professors are top-notch, and the campus is beautiful.",
  },
  {
    name: "Mark Johnson",
    university: "University of Oxford",
    photo: "https://randomuser.me/api/portraits/men/3.jpg", // Dummy photo URL
    rating: 4.0,
    message:
      "A great learning experience with a vibrant student community. experience! The professors are top-notch, and the campus is beautiful. experience! The professors are top-notch, and the campus is beautiful.",
  },
  {
    name: "Emily Davis",
    university: "MIT",
    photo: "https://randomuser.me/api/portraits/women/4.jpg", // Dummy photo URL
    rating: 5.0,
    message:
      "Hands down the best decision of my life! The resources and networking opportunities are endless. experience! The professors are top-notch, and the campus is beautiful. experience! The professors are top-notch, and the campus is beautiful.",
  },
  {
    name: "mohan",
    university: "MIT",
    photo: "https://randomuser.me/api/portraits/women/4.jpg", // Dummy photo URL
    rating: 5.0,
    message:
      "Hands down the best decision of my life! The resources and networking opportunities are endless. experience! The professors are top-notch, and the campus is beautiful. experience! The professors are top-notch, and the campus is beautiful.",
  },
];
